import { jsx as _jsx } from "react/jsx-runtime";
import { SHOWROOM_PATH_IDENTIFIER } from "@faire/retailer-shared/categories/pathIdentifier";
import { ImageTextLinkTile } from "@faire/retailer-visitor-shared/components/Carousel/ImageTextLinkTile";
import { categoryPath } from "@faire/retailer-visitor-shared/paths/category/categoryPath";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { findClosestActiveCategoryUrlIdsByPathIdentifier } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByPathIdentifier";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { observer } from "mobx-react";
import React from "react";
var AnimatedCategoryTileBase = function(param) {
    var categoryTile = param.categoryTile, handleStyledLinkOnClick = param.handleStyledLinkOnClick, imageSizeInfo = param.imageSizeInfo, dataTestId = param.dataTestId, className = param.className;
    var categories = useCategoryStore().categories;
    var routingContext = useRetailerRoutingContext();
    if (!categoryTile || !(categoryTile.image || categoryTile.images.length > 0) || !categoryTile.name || !categoryTile.category_path_identifier) {
        return null;
    }
    var isShowroom = categoryTile.category_path_identifier.includes(SHOWROOM_PATH_IDENTIFIER);
    var path = "";
    if (isNotUndefined(categoryTile.cta_link)) {
        path = categoryTile.cta_link;
    } else if (categoryTile.category_path_identifier) {
        var categoryUrlIds = findClosestActiveCategoryUrlIdsByPathIdentifier(categoryTile.category_path_identifier, categories);
        if (categoryUrlIds === undefined) {
            return null;
        }
        path = categoryPath({
            urlIds: categoryUrlIds,
            routingContext: routingContext
        });
    }
    return /*#__PURE__*/ _jsx(ImageTextLinkTile, {
        keyString: categoryTile.category_path_identifier,
        link: path,
        parentCategoryName: categoryTile.parent_category_name,
        text: categoryTile.name,
        image: categoryTile.image,
        imageSizeInfo: imageSizeInfo,
        handleStyledLinkOnClick: handleStyledLinkOnClick,
        dataTestId: dataTestId,
        className: className,
        useShowroomAnimatedTile: isShowroom,
        images: categoryTile.images
    });
};
export var AnimatedCategoryTile = observer(AnimatedCategoryTileBase);
